import React from 'react';

const TimeUtilization = () => {
  // In a real implementation, this would use a charting library like Chart.js
  const data = {
    clinical: 65,
    documentation: 18,
    admin: 12,
    research: 5
  };
  
  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-medium mb-3">Time Utilization</h3>
      
      <div className="flex items-center justify-center mb-4">
        <div className="w-40 h-40 relative rounded-full overflow-hidden">
          {/* Clinical segment */}
          <div 
            className="absolute bg-blue-500" 
            style={{
              width: '100%',
              height: '100%',
              clipPath: 'polygon(50% 50%, 50% 0%, 100% 0%, 100% 100%, 50% 100%)'
            }}
          ></div>
          
          {/* Documentation segment */}
          <div 
            className="absolute bg-green-500" 
            style={{
              width: '100%',
              height: '100%',
              clipPath: 'polygon(50% 50%, 50% 100%, 0% 100%, 0% 50%)'
            }}
          ></div>
          
          {/* Admin segment */}
          <div 
            className="absolute bg-orange-500" 
            style={{
              width: '100%',
              height: '100%',
              clipPath: 'polygon(50% 50%, 0% 50%, 0% 0%, 25% 0%)'
            }}
          ></div>
          
          {/* Research segment */}
          <div 
            className="absolute bg-purple-500" 
            style={{
              width: '100%',
              height: '100%',
              clipPath: 'polygon(50% 50%, 25% 0%, 50% 0%)'
            }}
          ></div>
        </div>
      </div>
      
      <div className="space-y-1 text-sm">
        <div className="flex justify-between">
          <span>Clinical:</span>
          <span className="font-medium">{data.clinical}%</span>
        </div>
        <div className="flex justify-between">
          <span>Documentation:</span>
          <span className="font-medium">{data.documentation}%</span>
        </div>
        <div className="flex justify-between">
          <span>Admin:</span>
          <span className="font-medium">{data.admin}%</span>
        </div>
        <div className="flex justify-between">
          <span>Research:</span>
          <span className="font-medium">{data.research}%</span>
        </div>
      </div>
    </div>
  );
};

export default TimeUtilization;